<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<div class="dashboard_new" *ngIf="!loader && inventoryStatusData.length == 0">
    <mat-card>
      <div class="upload_sectio">
       <div class="icm_img">
          <img src="./assets/images/s5.png">
       </div>
       <mat-card-title>Get real time inventory status</mat-card-title>
       <mat-card-content>Current inventory status ensures that your business can meet customer demand without delays. Prevent lost sales due to out-of-stock items, maintain customer satisfaction.
      </mat-card-content>
       <!-- <div class="watch_vc_btn">
          <button mat-stroked-button color="primary" (click)="openvideo()">
             <mat-icon>smart_display</mat-icon>
             Watch video
          </button>
       </div> -->
      </div>
    </mat-card>
 </div>

 <!-- with data -->

 <div class="today_booking_card" *ngIf="!loader && inventoryStatusData.length > 0">
    <mat-card>
    <div class="vier_tht"  >
       <div class="heading_ot">
       <h3>Inventory status</h3> 
      </div>
       <div class="view_all_btn" *ngIf="inventoryStatusData[0].total_count > 4">
        <a (click)="viewAll()">{{inventoryStatusData[0].total_count > 4 ? 'View all ' + inventoryStatusData[0].total_count : 'View details'}}</a>
      </div>
  </div>
  <!--  -->
  <div class="list_yy" *ngFor="let item of inventoryStatusData">
    <div class="bookign_img">
      <!-- <div class="status_yl"></div> -->
    <img [src]="item.image_thumb_url" onerror="this.src='../../../../../../assets/images/salon_support_header.png'" alt=""/>
    <span style="height: 15px; width: 15px; background-color: red; border-radius: 50%; display: block; position: absolute;bottom: -3px;
    left: 28px;" [ngStyle]="{'background-color': item.current_purchase_stock <= 0 || item.current_purchase_stock == null
    ? 'red'
    : item.current_purchase_stock > 0 && item.current_purchase_stock <= item.min_stock
        ? 'yellow'
        : 'green'}">
  
    </span>
    </div>
    <div class="booking_heading">
        <h3>{{item.item_name}}</h3>
        <p>{{item.quantity_info}} {{item.selling_unit}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.name}}</h3>
        <p>{{item.address_line}}</p>
    </div>
    <div class="booking_heading" style="text-align: end;">
        <h3>{{item.current_purchase_stock}} {{item.purchase_unit}}</h3>
    </div>
  </div>
  <div class="list_yy" style="height: 61px;" *ngFor="let item of repeatArray">
    
  </div>
</mat-card>

</div>